import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { AuthServiceProvider } from '../../api/auth'

const AuthService = AuthServiceProvider()
const name = 'createAccount'

export default ({ email, password, confirmPassword }) => (asyncAction(
  name,
  AuthService.createAccount,
  { email, password, confirmPassword }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/auth/createAccount.js